import React, { useState, useEffect } from "react";
import Button from "components/CustomButton";
import { ReactComponent as MicOnnIcon } from "assets/img/icons/mic.svg";
import micoff from "assets/img/icons/mic_off_watercooler.png";
import { ReactComponent as Exit } from "assets/img/icons/metro-exit.svg";
import { getAllMembers } from "services/TwilioService";
import { useWaterCoolerContext } from "store/contexts/waterCoolerContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as VideoIcon } from "assets/img/icons/video-camera-icon.svg";
// import Loader from "components/Loader";
import MembersOnline from "./MembersOnline";
import MemberAcitveDialog from "./MemberAcitveDialog";

export default ({
  videoContent,
  showVideoContent,
  closeVideoContent,
  memberCount = 4,
}) => {
  const {
    room,
    channelInformation,
    toggleVideo,
    // joinVideoCall,
    closeJoinWaterCooler,
    localVideo,
    // leaveVideoWaterCooler,
    microphone,
    toggleAudio,
  } = useWaterCoolerContext();
  const [allMembersOnline, setAllMembersOnline] = useState([]);
  const [joinVideoCall, setJoinVideoCall] = useState(false);
  // const [isLoading, setLoading] = useState(false);
  const buttonStyle = {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  };

  // const loadingStyle = {
  //   display: "flex",
  //   justifyContent: "center",
  // };

  useEffect(() => {
    return () => {
      if (localVideo) {
        localVideo.track.stop();
        localVideo.unpublish();
      }
    };
  }, [localVideo]);

  useEffect(() => {
    (async () => {
      try {
        var members = await getAllMembers(channelInformation);

        setAllMembersOnline(members);
      } catch (e) {
        console.log(e);
      }
    })();
    //eslint-disable-next-line
  }, []);

  const handleVideoContent = async (value) => {
    setJoinVideoCall(value);
    toggleVideo(room, value);
    if (!value) {
      closeVideoContent();
      return;
    }
    showVideoContent();

    // if (!videoContent && !room) {
    //   await joinVideoCall(setLoading);
    //   showVideoContent();
    //   return;
    // }
    // if (room) {
    //   await leaveVideoWaterCooler(setLoading);
    // }
    // if (room && videoContent) {
    //   showVideoContent();
    // }
  };

  return (
    <div className="wc-chat-header">
      <div className="wc-header-left">
        <MemberAcitveDialog
          allMembersOnline={allMembersOnline}
          memberCount={memberCount}
        >
          <div className="wc-active-users" style={{ cursor: "pointer" }}>
            <div className="text-white">Active Participants</div>
            {allMembersOnline.length !== 0 && (
              <MembersOnline
                memberCount={memberCount}
                allMembersOnline={allMembersOnline}
                changeMembers={(member) => setAllMembersOnline(member)}
              />
            )}
          </div>
        </MemberAcitveDialog>
        <div className="wc-videocall">
          <Button
            buttonClass="grad_btn join-btn"
            // disabled={isLoading && true}
            onClick={() => handleVideoContent(!joinVideoCall)}
            buttonStyle={buttonStyle}
          >
            <span className="mbl-none">
              {!joinVideoCall ? (
                <span>
                  Join Video Call
                  {/* {!isLoading && "Join Video Call"}
                  {isLoading && (
                    <Loader loaderStyle={loadingStyle} width={25} height={25} />
                  )} */}
                </span>
              ) : (
                <span>
                  Leave Video Call
                  {/* {!isLoading && "Leave Video Call"}
                  {isLoading && (
                    <Loader loaderStyle={loadingStyle} width={25} height={25} />
                  )} */}
                </span>
              )}
            </span>
          </Button>
          {!videoContent && joinVideoCall && (
            <Button buttonClass="outline-btn" onClick={showVideoContent}>
              <VideoIcon
                className="mw-22"
                style={{ fill: "white", cursor: "pointer" }}
              />
            </Button>
          )}
          {videoContent && (
            <Button buttonClass="outline-btn" onClick={showVideoContent}>
              <FontAwesomeIcon
                icon={faCommentDots}
                className="mw-22"
                style={{
                  color: "white",
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                }}
              />
            </Button>
          )}
          {!videoContent && (
            <Button
              buttonClass="outline-btn"
              onClick={() => toggleAudio(room, !microphone)}
            >
              {microphone && (
                <MicOnnIcon
                  style={{ color: "white", fill: "white" }}
                  className="mw-22"
                  alt="mic"
                />
              )}
              {!microphone && (
                <img className="mw-22" src={micoff} alt="micOff" />
              )}
            </Button>
          )}
        </div>
      </div>
      <div className="wc-header-right" onClick={closeJoinWaterCooler}>
        <span>
          <Exit className="exit" style={{ fill: "white" }} />
          <div className="leaveWaterCooler">Leave</div>
        </span>
      </div>
    </div>
  );
};
